import { render } from "./ForgotPasswordNewPassword.vue?vue&type=template&id=b683cace"
import script from "./ForgotPasswordNewPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordNewPassword.vue?vue&type=script&lang=js"
script.render = render

export default script